import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IhmExpandCollapsePanelComponent } from './ihm-expand-collapse-panel.component';

@NgModule({
  imports: [CommonModule, MatIconModule],
  declarations: [IhmExpandCollapsePanelComponent],
  exports: [IhmExpandCollapsePanelComponent]
})
export class IhmExpandCollapsePanelModule {}
